if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        this.buyNowButton = this.querySelector('.product-form__buynow');
        if (this.buyNowButton) {
          this.buyNowButton.addEventListener('click', this.onBuyNowHandler.bind(this));
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.sectionId = this.dataset.sectionId;
        this.totalPriceEl = this.querySelector('.product-form__total-price');
        this.quantityInput = document.getElementById(`Quantity-${this.sectionId}`);
        if (this.quantityInput && this.totalPriceEl) {
          this.quantityInput.addEventListener('change', this.updateTotalPrice.bind(this));
          this.quantityInput.addEventListener('input', this.updateTotalPrice.bind(this));
        }

        if (this.totalPriceEl) {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId === this.sectionId) {
              if (event.data.variant) {
                this.totalPriceEl.dataset.basePrice = event.data.variant.price;
              }
              // 延迟 50 毫秒以等待 DOM 替换，然后格式化主价格和更新总价
              setTimeout(() => {
                this.updateTotalPrice();
                this.formatAllPricesOnPage();
              }, 50);
            }
          });
        }

        // 页面初始加载时的格式化和总价计算
        setTimeout(() => {
          this.updateTotalPrice();
          this.formatAllPricesOnPage();
        }, 100);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      onBuyNowHandler(evt) {
        evt.preventDefault();
        if (this.buyNowButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.buyNowButton.setAttribute('aria-disabled', true);
        this.buyNowButton.classList.add('loading');
        const spinner = this.buyNowButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              this.buyNowButton.setAttribute('aria-disabled', true);
              this.error = true;
              return;
            }
            
            window.location = window.routes.cart_url.replace('/cart', '/checkout');
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.buyNowButton.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
            if (!this.error) this.buyNowButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          
          if (this.buyNowButton) {
            this.buyNowButton.setAttribute('disabled', 'disabled');
            const buyNowText = this.buyNowButton.querySelector('span');
            if (buyNowText && text) buyNowText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          
          if (this.buyNowButton) {
            this.buyNowButton.removeAttribute('disabled');
            const buyNowText = this.buyNowButton.querySelector('span');
            if (buyNowText) buyNowText.textContent = 'Buy Now';
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      updateTotalPrice() {
        if (!this.totalPriceEl) return;

        const basePrice = parseInt(this.totalPriceEl.dataset.basePrice || 0);
        const qty = this.quantityInput ? parseInt(this.quantityInput.value || 1) : 1;
        const totalCents = basePrice * qty;

        const format = this.totalPriceEl.dataset.moneyFormat || '${{amount}}';
        const moneyString = this.formatMoney(totalCents, format);
        this.totalPriceEl.innerHTML = this.parseAndFormatPrice(moneyString);
      }

      formatMoney(cents, format) {
        if (typeof cents === 'string') cents = cents.replace('.', '');
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || '${{amount}}';

        function defaultOption(opt, def) {
          return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal   = defaultOption(decimal, '.');

          if (isNaN(number) || number == null) { return 0; }

          number = (number/100.0).toFixed(precision);

          const parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';

          return dollars + cents;
        }

        const match = formatString.match(placeholderRegex);
        if (!match) return formatString;

        switch(match[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          default:
            value = formatWithDelimiters(cents, 2);
            break;
        }

        return formatString.replace(placeholderRegex, value);
      }

      parseAndFormatPrice(priceString) {
        const numMatch = priceString.match(/(\d[\d\.,]*)/);
        if (!numMatch) return priceString;

        const numStr = numMatch[1];
        let prefix = priceString.substring(0, numMatch.index).trim();
        let suffix = priceString.substring(numMatch.index + numStr.length).trim();

        let integerPart = numStr;
        let decimalPart = "";

        const lastDotOrCommaIndex = numStr.search(/[\.,]\d{2}$/);
        if (lastDotOrCommaIndex !== -1) {
          integerPart = numStr.substring(0, lastDotOrCommaIndex);
          decimalPart = numStr.substring(lastDotOrCommaIndex); // 保留小数点或逗号，使价格认读更清晰
        }

        let html = `<span class="price-container">`;
        
        if (prefix) {
          html += `<span class="price-currency">${prefix}</span>`;
        }
        
        html += `<span class="price-integer">${integerPart}</span>`;
        
        if (decimalPart) {
          html += `<span class="price-fraction">${decimalPart}</span>`;
        }
        
        if (suffix) {
          html += `<span class="price-code">${suffix}</span>`;
        }
        
        html += `</span>`;
        return html;
      }

      formatAllPricesOnPage() {
        let productInfo = this.closest('product-info');
        if (!productInfo) {
          productInfo = document.querySelector('product-info');
        }
        if (!productInfo) return;

        const salePrice = productInfo.querySelector('.price--large .price-item--sale');
        if (salePrice && !salePrice.querySelector('.price-integer')) {
          salePrice.style.lineHeight = '1';
          salePrice.innerHTML = this.parseAndFormatPrice(salePrice.textContent.trim());
        }

        const regularPrice = productInfo.querySelector('.price--large .price-item--regular');
        if (regularPrice && !regularPrice.querySelector('.price-integer')) {
          regularPrice.style.lineHeight = '1';
          regularPrice.innerHTML = this.parseAndFormatPrice(regularPrice.textContent.trim());
        }
      }
    }
  );
}
